import { useMemo } from 'react'
import { getPlatformAPI, getPlatformInfo } from '../lib/platform'

/**
 * Hook to access platform API and info
 */
export function usePlatform() {
  const platformAPI = useMemo(() => getPlatformAPI(), [])
  const platformInfo = useMemo(() => getPlatformInfo(), [])

  return {
    api: platformAPI,
    info: platformInfo,
    platform: platformInfo.platform,
    isElectron: platformInfo.isElectron,
    isWeb: platformInfo.isWeb,
    isMac: platformInfo.isMac,
    isWindows: platformInfo.isWindows,
    isLinux: platformInfo.isLinux,
  }
}
